/**
 * Arbeidsrett Module Description
 * Master Grade modul for arbeidsrettslige prosesser
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const ARBEIDSRETT_CONFIG = {
  id: 'arbeidsrett',
  title: 'Arbeidsrett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen arbeidsrett med lokal AI-drevet tekstanalyse, automatisk fristberegning og generering av strukturerte dokumentutkast. Modulen er utviklet for å gi et helhetlig arbeidsverktøy for kontrakter, oppsigelser og øvrige arbeidsrettslige prosesser.",
  
  aboutModule: "Arbeidsrett-modulen gir verktøy for å utforme, analysere og kvalitetssikre arbeidskontrakter, vurdere oppsigelser og beregne relevante frister og rettigheter etter arbeidsmiljøloven.",
  
  features: [
    "Avansert kontraktgenerator med støtte for konkurranseklausuler, immaterielle rettigheter og øvrige sentrale kontraktspunkter",
    "Det juridiske skjoldet – kontroll av formkrav og prosessuelle krav ved oppsigelse",
    "AI-drevet analyse av eksisterende arbeidskontrakter",
    "Validator for vurdering av særlig uavhengig stilling etter arbeidsmiljøloven § 10-12",
    "Automatisk beregning av oppsigelsestid, frister og relevante tidsløp"
  ],
  
  privacyText: "All behandling og lagring skjer lokalt på din enhet. Dokumenter og metadata lagres ikke på servere og deles ikke med RettVerk."
};

export function ArbeidsrettDescription() {
  const config = ARBEIDSRETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default ArbeidsrettDescription;
